import {makeAutoObservable} from "mobx";
import axiosInstance from "../axios/index";

class ContractsStore {
  constructor() {
    makeAutoObservable(this);
  }

  async getProjectsInContracts() {
    return axiosInstance.get("contracts/projects").then(({data}) => data);
  }

  async getContracts(params = {}) {
    return axiosInstance.get("contracts", {params}).then(({data}) => data);
  }

  async getUploadedContract(id) {
    return axiosInstance.get(`uploaded-contract/${id}`).then(({data}) => data);
  }
  async getFileUID(file) {
    return axiosInstance
      .post("uploaded-contract/file-upload", file)
      .then((res) => res.data);
  }

  async createUploadedContract(data) {
    return axiosInstance
      .post("uploaded-contract", data)
      .then(({data}) => data)
      .finally(() => {
        this.uploadContractloading = false;
      });
  }

  async updateUploadedContract(id, data) {
    return axiosInstance
      .patch(`uploaded-contract/${id}`, data)
      .then(({data}) => data)
      .finally(() => {
        this.uploadContractloading = false;
      });
  }

  async deleteUploadedContract(id) {
    return axiosInstance.delete(`uploaded-contract/${id}`);
  }
}

const contractsStore = new ContractsStore();
export default contractsStore;
